import React, { useState } from 'react';
import '../styles/Global.css';
import logo from '../assets/logo/consphic.svg';
import search from '../assets/logo/search.svg';

const Header: React.FC = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    const toggleMenu = () => setMenuOpen(!menuOpen);

    
    return (
        <header className="page-header">
            <div className="header-logo">
                <a href="/" >
                    <img src={logo} alt="Consphic Logo" className="logo-image" />
                </a>
            </div>
            <nav className={`header-nav ${menuOpen ? 'open' : ''}`}>
                {[
                    { href: '/about', label: 'Who we are' },
                    { href: '/services', label: 'What we do' },
                    { href: '/careers', label: 'Careers' },
                    { href: '/contact', label: 'Contact Us' }
                ].map((link) => (
                    <div className="header-link-wrapper" key={link.href}>
                        <a
                            href={link.href}
                            className="header-link"
                        >
                            {link.label}
                            <span className="header-link-arrow">
                                <svg className="arrow-svg" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5 7L9 11L13 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </span>
                        </a>
                        <span className="header-link-underline" />
                    </div>
                ))}
                {menuOpen && (
                    <button
                        className="mobile-menu-close"
                        onClick={toggleMenu}
                        aria-label="Close menu"
                        type="button"
                    >
                        &times;
                    </button>
                )}
            </nav>
            <button className="hamburger-menu" onClick={toggleMenu}>
                ☰
            </button>
            <div className="header-search">
                <img src={search} alt="Search" className="search-icon-css" />             
            </div>
        </header>
    );
};

export default Header;